
import state from './moduleProgressState.js'
import mutations from './moduleProgressMutations.js'
import actions from './moduleProgressActions.js'
import getters from './moduleProgressGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
